module.exports = __webpack_public_path__ + "static/media/emergencyContactGray.44114aff.png";